<template>
  <div class="typing-planet-container">
    <div class="header">
      <div class="header-left">
        <button class="back-button" @click="goBack">
          <i class="back-icon">←</i> 返回
        </button>
      </div>
      <h1>{{ $route.query.title || '第一组 水果分类' }}</h1>
      <div class="score-board">
     
        得分: {{ score }}
      </div>
    </div>
    
    <div class="game-area">
      <div class="fruit-card" :class="{ 'animated': isAnimating }">
        <div class="card-content">
          <div class="tone-hint">{{ currentWord.pinyinWithTone }}</div>
          <div class="fruit-character">{{ currentWord.character }}</div>
         
        </div>
      </div>
      
      <div class="pinyin-input-area">
        <p class="prompt">请输入"{{ currentWord.character }}"的拼音：</p>
        
        <div class="pinyin-inputs-container">
          <!-- 为每个字符创建对应的输入框 -->
          <div v-for="(char, index) in currentWord.character" :key="index" class="character-pinyin-group">

            <input 
              v-model="pinyinInputs[index]" 
              :ref="`pinyinInput${index}`"
              :disabled="isChecking"
              class="pinyin-input"
              :placeholder="`${char}的拼音`"
              maxlength="6"
            />
          </div>
        </div>
        
        <button @click="checkAnswer" class="check-button" :disabled="isChecking">
          <span v-if="!isChecking">
            <i class="check-icon">✓</i> 确认答案
          </span>
          <span v-else>检查中...</span>
        </button>

        <div class="navigation">
          <button @click="previousWord" class="nav-button prev-button">
            <i class="nav-icon">←</i> 上一个
          </button>
          <button @click="nextWord" class="nav-button next-button">
            下一个 <i class="nav-icon">→</i>
          </button>
        </div>
      </div>
      
      <div class="result-message" v-if="showResult">
        <div v-if="isCorrect" class="correct animated-feedback">
          <div class="feedback-content">
            <span class="feedback-text">太棒了！</span>
            <img src="https://wugecdn.steam.fun/typefun/images/excellent.png" alt="正确" class="result-icon bounce-animation" />
          </div>
          <div class="confetti-container">
            <div v-for="n in 20" :key="n" class="confetti" :style="`--delay: ${n * 0.1}s; --n: ${n};`"></div>
          </div>
        </div>
        <div v-else class="incorrect animated-feedback">
          <div class="feedback-content">
            <span class="feedback-text">再试一次，正确答案是: </span>
            <span class="correct-answer">{{ currentWord.pinyinWithTone }}</span>
            <img src="https://wugecdn.steam.fun/typefun/images/keep-trying.png" alt="错误" class="result-icon shake-animation" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- 学习报告模态框 -->
    <div class="report-overlay" v-if="showReport" @click.self="closeReport">
      <div class="report-modal">
        <div class="report-header">
          <h2>学习报告</h2>
          <button class="close-report" @click="closeReport">×</button>
        </div>
        
        <div class="report-content">
          <div class="report-summary">
            <div class="report-total">
              <div class="report-icon-container">
                <img src="https://wugecdn.steam.fun/typefun/images/excellent.png" alt="报告" class="report-icon" />
              </div>
              <div class="report-stats">
                <p>总共完成: <span class="highlight">{{ completedCount }}</span> / {{ currentVocabulary.length }}</p>
                <p>正确率: <span class="highlight">{{ correctPercentage }}%</span></p>
                <p>总得分: <span class="highlight">{{ score }}</span></p>
              </div>
            </div>
            
            <div class="report-progress">
              <div class="progress-bar">
                <div class="progress-fill" :style="`width: ${correctPercentage}%`"></div>
              </div>
            </div>
          </div>
          
          <div class="report-details">
            <h3>词汇掌握情况</h3>
            <div class="vocabulary-list">
              <div v-for="(item, index) in learningProgress" :key="index" class="vocabulary-item">
                <div class="vocab-character">{{ item.character }}</div>
                <div class="vocab-pinyin">{{ item.pinyinWithTone }}</div>
                <div :class="['vocab-status', item.correct ? 'status-correct' : 'status-incorrect']">
                  <i v-if="item.correct" class="status-icon">✓</i>
                  <i v-else class="status-icon">✗</i>
                </div>
              </div>
            </div>
          </div>
          
          <div class="report-actions">
            <button class="restart-button" @click="restartLearning">
              <i class="restart-icon">↺</i> 重新学习
            </button>
            <button class="continue-button" @click="closeReport">
              继续 <i class="continue-icon">→</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TypingPlanetWords",
  data() {
    return {
      // 将不同类别的词汇分开存储
      vocabularyGroups: {
        fruits: [
          { character: "苹果", pinyin: "ping guo", pinyinWithTone: "píng guǒ"},
          { character: "香蕉", pinyin: "xiang jiao", pinyinWithTone: "xiāng jiāo"},
          { character: "橙子", pinyin: "cheng zi", pinyinWithTone: "chéng zi"},
          { character: "西瓜", pinyin: "xi gua", pinyinWithTone: "xī guā"},
          { character: "草莓", pinyin: "cao mei", pinyinWithTone: "cǎo méi"},
          { character: "葡萄", pinyin: "pu tao", pinyinWithTone: "pú táo"},
          { character: "芒果", pinyin: "mang guo", pinyinWithTone: "máng guǒ"},
          { character: "柠檬", pinyin: "ning meng", pinyinWithTone: "níng méng"},
          { character: "桃子", pinyin: "tao zi", pinyinWithTone: "táo zi"},
          { character: "梨子", pinyin: "li zi", pinyinWithTone: "lí zi"},
          { character: "樱桃", pinyin: "ying tao", pinyinWithTone: "yīng táo"},
          { character: "猕猴桃", pinyin: "mi hou tao", pinyinWithTone: "mí hóu táo"},
          { character: "榴莲", pinyin: "liu lian", pinyinWithTone: "liú lián"},
          { character: "椰子", pinyin: "ye zi", pinyinWithTone: "yē zi"},
          { character: "菠萝", pinyin: "bo luo", pinyinWithTone: "bō luó"},
          { character: "石榴", pinyin: "shi liu", pinyinWithTone: "shí liú"}
        ],
        animals: [
          { character: "猫", pinyin: "mao", pinyinWithTone: "māo"},
          { character: "狗", pinyin: "gou", pinyinWithTone: "gǒu"},
          { character: "鸟", pinyin: "niao", pinyinWithTone: "niǎo"},
          { character: "鱼", pinyin: "yu", pinyinWithTone: "yú"},
          { character: "兔", pinyin: "tu", pinyinWithTone: "tù"},
          { character: "熊", pinyin: "xiong", pinyinWithTone: "xióng"},
          { character: "狮子", pinyin: "shi zi", pinyinWithTone: "shī zi"},
          { character: "老虎", pinyin: "lao hu", pinyinWithTone: "lǎo hǔ"},
          { character: "大象", pinyin: "da xiang", pinyinWithTone: "dà xiàng"},
          { character: "熊猫", pinyin: "xiong mao", pinyinWithTone: "xióng māo"},
          { character: "猴子", pinyin: "hou zi", pinyinWithTone: "hóu zi"},
          { character: "孔雀", pinyin: "kong que", pinyinWithTone: "kǒng què"},
          { character: "长颈鹿", pinyin: "chang jing lu", pinyinWithTone: "cháng jǐng lù"},
          { character: "企鹅", pinyin: "qi e", pinyinWithTone: "qǐ é"},
          { character: "袋鼠", pinyin: "dai shu", pinyinWithTone: "dài shǔ"},
          { character: "考拉", pinyin: "kao la", pinyinWithTone: "kǎo lā"}
        ],
        colors: [
          { character: "红色", pinyin: "hong se", pinyinWithTone: "hóng sè"},
          { character: "蓝色", pinyin: "lan se", pinyinWithTone: "lán sè"},
          { character: "绿色", pinyin: "lv se", pinyinWithTone: "lǜ sè"},
          { character: "黄色", pinyin: "huang se", pinyinWithTone: "huáng sè"},
          { character: "紫色", pinyin: "zi se", pinyinWithTone: "zǐ sè"},
          { character: "橙色", pinyin: "cheng se", pinyinWithTone: "chéng sè"},
          { character: "粉色", pinyin: "fen se", pinyinWithTone: "fěn sè"},
          { character: "棕色", pinyin: "zong se", pinyinWithTone: "zōng sè"},
          { character: "灰色", pinyin: "hui se", pinyinWithTone: "huī sè"},
          { character: "黑色", pinyin: "hei se", pinyinWithTone: "hēi sè"},
          { character: "白色", pinyin: "bai se", pinyinWithTone: "bái sè"},
          { character: "金色", pinyin: "jin se", pinyinWithTone: "jīn sè"},
          { character: "银色", pinyin: "yin se", pinyinWithTone: "yín sè"},
          { character: "灰色", pinyin: "hui se", pinyinWithTone: "huī sè"},
          { character: "黑色", pinyin: "hei se", pinyinWithTone: "hēi sè"},
        ],
        numbers: [
          { character: "一", pinyin: "yi", pinyinWithTone: "yī"},
          { character: "二", pinyin: "er", pinyinWithTone: "èr"},
          { character: "三", pinyin: "san", pinyinWithTone: "sān"},
          { character: "四", pinyin: "si", pinyinWithTone: "sì"},
          { character: "五", pinyin: "wu", pinyinWithTone: "wǔ"},
          { character: "六", pinyin: "liu", pinyinWithTone: "liù"},
          { character: "七", pinyin: "qi", pinyinWithTone: "qī"},
          { character: "八", pinyin: "ba", pinyinWithTone: "bā"},
          { character: "九", pinyin: "jiu", pinyinWithTone: "jiǔ"},
          { character: "十", pinyin: "shi", pinyinWithTone: "shí"},
          { character: "零", pinyin: "ling", pinyinWithTone: "líng"},
          { character: "百", pinyin: "bai", pinyinWithTone: "bǎi"},
          { character: "千", pinyin: "qian", pinyinWithTone: "qiān"},
          { character: "万", pinyin: "wan", pinyinWithTone: "wàn"},
          { character: "亿", pinyin: "yi", pinyinWithTone: "yì"},
          { character: "兆", pinyin: "zhao", pinyinWithTone: "zhào"},
        ],
        direction: [
          { character: "上", pinyin: "shang", pinyinWithTone: "shàng"},
          { character: "下", pinyin: "xia", pinyinWithTone: "xià"},
          { character: "左", pinyin: "zuo", pinyinWithTone: "zuǒ"},
          { character: "右", pinyin: "you", pinyinWithTone: "yòu"},
          { character: "前", pinyin: "qian", pinyinWithTone: "qián"},
          { character: "后", pinyin: "hou", pinyinWithTone: "hòu"},
          { character: "东", pinyin: "dong", pinyinWithTone: "dōng"},
          { character: "西", pinyin: "xi", pinyinWithTone: "xī"},
          { character: "南", pinyin: "nan", pinyinWithTone: "nán"},
          { character: "北", pinyin: "bei", pinyinWithTone: "běi"},
        ],
        goods: [
          { character: "书包", pinyin: "shu", pinyinWithTone: "shū"},
          { character: "书", pinyin: "shu", pinyinWithTone: "shū"},
          { character: "笔", pinyin: "bi", pinyinWithTone: "bǐ"},
          { character: "桌", pinyin: "zhuo", pinyinWithTone: "zhuō"},
          { character: "椅", pinyin: "yi", pinyinWithTone: "yǐ"},
          { character: "杯", pinyin: "bei", pinyinWithTone: "bēi"},
          { character: "包", pinyin: "bao", pinyinWithTone: "bāo"},
          { character: "伞", pinyin: "san", pinyinWithTone: "sǎn"},
          { character: "钟", pinyin: "zhong", pinyinWithTone: "zhōng"},
          { character: "灯", pinyin: "deng", pinyinWithTone: "dēng"},
          { character: "门", pinyin: "men", pinyinWithTone: "mén"},
          { character: "窗", pinyin: "chuang", pinyinWithTone: "chuāng"},
          { character: "鞋", pinyin: "xie", pinyinWithTone: "xié"},
          { character: "帽", pinyin: "mao", pinyinWithTone: "mào"},
          { character: "镜", pinyin: "jing", pinyinWithTone: "jìng"},
          { character: "床", pinyin: "chuang", pinyinWithTone: "chuáng"}  
        ],
        weather: [
          { character: "晴天", pinyin: "qing tian", pinyinWithTone: "qíng tiān"},
          { character: "雨天", pinyin: "yu tian", pinyinWithTone: "yǔ tiān"},
          { character: "阴天", pinyin: "yin tian", pinyinWithTone: "yīn tiān"},
          { character: "雪", pinyin: "xue", pinyinWithTone: "xuě"},
          { character: "风", pinyin: "feng", pinyinWithTone: "fēng"},
          { character: "雷", pinyin: "lei", pinyinWithTone: "léi"},
          { character: "雾", pinyin: "wu", pinyinWithTone: "wù"},
          { character: "霜", pinyin: "shuang", pinyinWithTone: "shuāng"},
          { character: "冰雹", pinyin: "bing bao", pinyinWithTone: "bīng báo"},
          { character: "台风", pinyin: "tai feng", pinyinWithTone: "tái fēng"},
          { character: "暴雨", pinyin: "bao yu", pinyinWithTone: "bào yǔ"},
          { character: "寒冷", pinyin: "han leng", pinyinWithTone: "hán lěng"},
          { character: "炎热", pinyin: "yan re", pinyinWithTone: "yán rè"},
          { character: "潮湿", pinyin: "chao shi", pinyinWithTone: "cháo shī"},
          { character: "干燥", pinyin: "gan zao", pinyinWithTone: "gān zào"}
        ],
        time: [
          { character: "早上", pinyin: "zao shang", pinyinWithTone: "zǎo shang"},
          { character: "中午", pinyin: "zhong wu", pinyinWithTone: "zhōng wǔ"},
          { character: "晚上", pinyin: "wan shang", pinyinWithTone: "wǎn shang"},
          { character: "昨天", pinyin: "zuo tian", pinyinWithTone: "zuó tiān"},
          { character: "今天", pinyin: "jin tian", pinyinWithTone: "jīn tiān"},
          { character: "明天", pinyin: "ming tian", pinyinWithTone: "míng tiān"},
          { character: "周末", pinyin: "zhou mo", pinyinWithTone: "zhōu mò"},
          { character: "星期", pinyin: "xing qi", pinyinWithTone: "xīng qī"},
          { character: "月份", pinyin: "yue fen", pinyinWithTone: "yuè fèn"},
          { character: "年代", pinyin: "nian dai", pinyinWithTone: "nián dài"},
          { character: "季节", pinyin: "ji jie", pinyinWithTone: "jì jié"},
          { character: "瞬间", pinyin: "shun jian", pinyinWithTone: "shùn jiān"},
          { character: "时刻", pinyin: "shi ke", pinyinWithTone: "shí kè"},
          { character: "日期", pinyin: "ri qi", pinyinWithTone: "rì qī"},
          { character: "世纪", pinyin: "shi ji", pinyinWithTone: "shì jì"}
        ],
      family: [
          { character: "爸爸", pinyin: "ba ba", pinyinWithTone: "bà ba"},
          { character: "妈妈", pinyin: "ma ma", pinyinWithTone: "mā ma"},
          { character: "哥哥", pinyin: "ge ge", pinyinWithTone: "gē ge"},
          { character: "姐姐", pinyin: "jie jie", pinyinWithTone: "jiě jie"},
          { character: "弟弟", pinyin: "di di", pinyinWithTone: "dì di"},
          { character: "妹妹", pinyin: "mei mei", pinyinWithTone: "mèi mei"},
          { character: "爷爷", pinyin: "ye ye", pinyinWithTone: "yé ye"},
          { character: "奶奶", pinyin: "nai nai", pinyinWithTone: "nǎi nai"},
          { character: "外公", pinyin: "wai gong", pinyinWithTone: "wài gōng"},
          { character: "外婆", pinyin: "wai po", pinyinWithTone: "wài pó"},
          { character: "叔叔", pinyin: "shu shu", pinyinWithTone: "shū shu"},
          { character: "阿姨", pinyin: "a yi", pinyinWithTone: "ā yí"},
          { character: "堂兄", pinyin: "tang xiong", pinyinWithTone: "táng xiōng"},
          { character: "表妹", pinyin: "biao mei", pinyinWithTone: "biǎo mèi"},
          { character: "孙子", pinyin: "sun zi", pinyinWithTone: "sūn zi"}
        ],
        nature: [
          { character: "山", pinyin: "shan", pinyinWithTone: "shān"},
          { character: "河", pinyin: "he", pinyinWithTone: "hé"},
          { character: "海", pinyin: "hai", pinyinWithTone: "hǎi"},
          { character: "湖", pinyin: "hu", pinyinWithTone: "hú"},
          { character: "森林", pinyin: "sen lin", pinyinWithTone: "sēn lín"},
          { character: "草原", pinyin: "cao yuan", pinyinWithTone: "cǎo yuán"},
          { character: "沙漠", pinyin: "sha mo", pinyinWithTone: "shā mò"},
          { character: "瀑布", pinyin: "pu bu", pinyinWithTone: "pù bù"},
          { character: "峡谷", pinyin: "xia gu", pinyinWithTone: "xiá gǔ"},
          { character: "岛屿", pinyin: "dao yu", pinyinWithTone: "dǎo yǔ"},
          { character: "高原", pinyin: "gao yuan", pinyinWithTone: "gāo yuán"},
          { character: "冰川", pinyin: "bing chuan", pinyinWithTone: "bīng chuān"},
          { character: "绿洲", pinyin: "lv zhou", pinyinWithTone: "lǜ zhōu"},
          { character: "悬崖", pinyin: "xuan ya", pinyinWithTone: "xuán yá"},
          { character: "平原", pinyin: "ping yuan", pinyinWithTone: "píng yuán"}
        ],
        transport: [
          { character: "汽车", pinyin: "qi che", pinyinWithTone: "qì chē"},
          { character: "自行车", pinyin: "zi xing che", pinyinWithTone: "zì xíng chē"},
          { character: "公交车", pinyin: "gong jiao che", pinyinWithTone: "gōng jiāo chē"},
          { character: "火车", pinyin: "huo che", pinyinWithTone: "huǒ chē"},
          { character: "飞机", pinyin: "fei ji", pinyinWithTone: "fēi jī"},
          { character: "轮船", pinyin: "lun chuan", pinyinWithTone: "lún chuán"},
          { character: "地铁", pinyin: "di tie", pinyinWithTone: "dì tiě"},
          { character: "摩托车", pinyin: "mo tuo che", pinyinWithTone: "mó tuō chē"},
          { character: "出租车", pinyin: "chu zu che", pinyinWithTone: "chū zū chē"},
          { character: "电动车", pinyin: "dian dong che", pinyinWithTone: "diàn dòng chē"},
          { character: "高铁", pinyin: "gao tie", pinyinWithTone: "gāo tiě"},
          { character: "直升机", pinyin: "zhi sheng ji", pinyinWithTone: "zhí shēng jī"},
          { character: "三轮车", pinyin: "san lun che", pinyinWithTone: "sān lún chē"},
          { character: "货车", pinyin: "huo che", pinyinWithTone: "huò chē"},
          { character: "救护车", pinyin: "jiu hu che", pinyinWithTone: "jiù hù chē"}
        ],
        furniture: [
          { character: "沙发", pinyin: "sha fa", pinyinWithTone: "shā fā"},
          { character: "电视", pinyin: "dian shi", pinyinWithTone: "diàn shì"},
          { character: "冰箱", pinyin: "bing xiang", pinyinWithTone: "bīng xiāng"},
          { character: "洗衣机", pinyin: "xi yi ji", pinyinWithTone: "xǐ yī jī"},
          { character: "空调", pinyin: "kong tiao", pinyinWithTone: "kōng tiáo"},
          { character: "微波炉", pinyin: "wei bo lu", pinyinWithTone: "wēi bō lú"},
          { character: "书柜", pinyin: "shu gui", pinyinWithTone: "shū guì"},
          { character: "衣柜", pinyin: "yi gui", pinyinWithTone: "yī guì"},
          { character: "餐桌", pinyin: "can zhuo", pinyinWithTone: "cān zhuō"},
          { character: "茶几", pinyin: "cha ji", pinyinWithTone: "chá jī"},
          { character: "台灯", pinyin: "tai deng", pinyinWithTone: "tái dēng"},
          { character: "电脑", pinyin: "dian nao", pinyinWithTone: "diàn nǎo"},
          { character: "热水器", pinyin: "re shui qi", pinyinWithTone: "rè shuǐ qì"},
          { character: "吸尘器", pinyin: "xi chen qi", pinyinWithTone: "xī chén qì"},
          { character: "电饭煲", pinyin: "dian fan bao", pinyinWithTone: "diàn fàn bāo"}
        ],
        adjectives: [
          { character: "大", pinyin: "da", pinyinWithTone: "dà"},
          { character: "小", pinyin: "xiao", pinyinWithTone: "xiǎo"},
          { character: "高", pinyin: "gao", pinyinWithTone: "gāo"},
          { character: "矮", pinyin: "ai", pinyinWithTone: "ǎi"},
          { character: "胖", pinyin: "pang", pinyinWithTone: "pàng"},
          { character: "瘦", pinyin: "shou", pinyinWithTone: "shòu"},
          { character: "快", pinyin: "kuai", pinyinWithTone: "kuài"},
          { character: "慢", pinyin: "man", pinyinWithTone: "màn"},
          { character: "好", pinyin: "hao", pinyinWithTone: "hǎo"},
          { character: "坏", pinyin: "huai", pinyinWithTone: "huài"},
          { character: "新", pinyin: "xin", pinyinWithTone: "xīn"},
          { character: "旧", pinyin: "jiu", pinyinWithTone: "jiù"},
          { character: "冷", pinyin: "leng", pinyinWithTone: "lěng"},
          { character: "热", pinyin: "re", pinyinWithTone: "rè"},
          { character: "硬", pinyin: "ying", pinyinWithTone: "yìng"}
        ],
        professions: [
          { character: "医生", pinyin: "yi sheng", pinyinWithTone: "yī shēng"},
          { character: "老师", pinyin: "lao shi", pinyinWithTone: "lǎo shī"},
          { character: "警察", pinyin: "jing cha", pinyinWithTone: "jǐng chá"},
          { character: "工程师", pinyin: "gong cheng shi", pinyinWithTone: "gōng chéng shī"},
          { character: "厨师", pinyin: "chu shi", pinyinWithTone: "chú shī"},
          { character: "司机", pinyin: "si ji", pinyinWithTone: "sī jī"},
          { character: "农民", pinyin: "nong min", pinyinWithTone: "nóng mín"},
          { character: "演员", pinyin: "yan yuan", pinyinWithTone: "yǎn yuán"},
          { character: "歌手", pinyin: "ge shou", pinyinWithTone: "gē shǒu"},
          { character: "记者", pinyin: "ji zhe", pinyinWithTone: "jì zhě"},
          { character: "律师", pinyin: "lv shi", pinyinWithTone: "lǜ shī"},
          { character: "科学家", pinyin: "ke xue jia", pinyinWithTone: "kē xué jiā"},
          { character: "作家", pinyin: "zuo jia", pinyinWithTone: "zuò jiā"},
          { character: "画家", pinyin: "hua jia", pinyinWithTone: "huà jiā"},
          { character: "运动员", pinyin: "yun dong yuan", pinyinWithTone: "yùn dòng yuán"}
        ],
        festivals: [
          { character: "春节", pinyin: "chun jie", pinyinWithTone: "chūn jié"},
          { character: "元宵节", pinyin: "yuan xiao jie", pinyinWithTone: "yuán xiāo jié"},
          { character: "清明节", pinyin: "qing ming jie", pinyinWithTone: "qīng míng jié"},
          { character: "端午节", pinyin: "duan wu jie", pinyinWithTone: "duān wǔ jié"},
          { character: "中秋节", pinyin: "zhong qiu jie", pinyinWithTone: "zhōng qiū jié"},
          { character: "国庆节", pinyin: "guo qing jie", pinyinWithTone: "guó qìng jié"},
          { character: "元旦", pinyin: "yuan dan", pinyinWithTone: "yuán dàn"},
          { character: "圣诞节", pinyin: "sheng dan jie", pinyinWithTone: "shèng dàn jié"},
          { character: "感恩节", pinyin: "gan en jie", pinyinWithTone: "gǎn ēn jié"},
          { character: "情人节", pinyin: "qing ren jie", pinyinWithTone: "qíng rén jié"},
          { character: "母亲节", pinyin: "mu qin jie", pinyinWithTone: "mǔ qīn jié"},
          { character: "父亲节", pinyin: "fu qin jie", pinyinWithTone: "fù qīn jié"},
          { character: "儿童节", pinyin: "er tong jie", pinyinWithTone: "ér tóng jié"},
          { character: "教师节", pinyin: "jiao shi jie", pinyinWithTone: "jiào shī jié"},
          { character: "重阳节", pinyin: "chong yang jie", pinyinWithTone: "chóng yáng jié"}
        ],
        food: [
          { character: "米饭", pinyin: "mi fan", pinyinWithTone: "mǐ fàn"},
          { character: "面条", pinyin: "mian tiao", pinyinWithTone: "miàn tiáo"},
          { character: "饺子", pinyin: "jiao zi", pinyinWithTone: "jiǎo zi"},
          { character: "包子", pinyin: "bao zi", pinyinWithTone: "bāo zi"},
          { character: "豆腐", pinyin: "dou fu", pinyinWithTone: "dòu fu"},
          { character: "牛肉", pinyin: "niu rou", pinyinWithTone: "niú ròu"},
          { character: "鸡蛋", pinyin: "ji dan", pinyinWithTone: "jī dàn"},
          { character: "蔬菜", pinyin: "shu cai", pinyinWithTone: "shū cài"},
          { character: "茶", pinyin: "cha", pinyinWithTone: "chá"},
          { character: "咖啡", pinyin: "ka fei", pinyinWithTone: "kā fēi"},
          { character: "牛奶", pinyin: "niu nai", pinyinWithTone: "niú nǎi"},
          { character: "果汁", pinyin: "guo zhi", pinyinWithTone: "guǒ zhī"},
          { character: "啤酒", pinyin: "pi jiu", pinyinWithTone: "pí jiǔ"},
          { character: "可乐", pinyin: "ke le", pinyinWithTone: "kě lè"},
          { character: "汤", pinyin: "tang", pinyinWithTone: "tāng"}
        ],
        emotions: [
          { character: "高兴", pinyin: "gao xing", pinyinWithTone: "gāo xìng"},
          { character: "悲伤", pinyin: "bei shang", pinyinWithTone: "bēi shāng"},
          { character: "愤怒", pinyin: "fen nu", pinyinWithTone: "fèn nù"},
          { character: "害怕", pinyin: "hai pa", pinyinWithTone: "hài pà"},
          { character: "惊讶", pinyin: "jing ya", pinyinWithTone: "jīng yà"},
          { character: "担心", pinyin: "dan xin", pinyinWithTone: "dān xīn"},
          { character: "紧张", pinyin: "jin zhang", pinyinWithTone: "jǐn zhāng"},
          { character: "兴奋", pinyin: "xing fen", pinyinWithTone: "xīng fèn"},
          { character: "失望", pinyin: "shi wang", pinyinWithTone: "shī wàng"},
          { character: "满足", pinyin: "man zu", pinyinWithTone: "mǎn zú"},
          { character: "羞愧", pinyin: "xiu kui", pinyinWithTone: "xiū kuì"},
          { character: "嫉妒", pinyin: "ji du", pinyinWithTone: "jí dù"},
          { character: "感激", pinyin: "gan ji", pinyinWithTone: "gǎn jī"},
          { character: "骄傲", pinyin: "jiao ao", pinyinWithTone: "jiāo ào"},
          { character: "困惑", pinyin: "kun huo", pinyinWithTone: "kùn huò"}
        ],
        bodyparts: [
          { character: "头", pinyin: "tou", pinyinWithTone: "tóu"},
          { character: "眼睛", pinyin: "yan jing", pinyinWithTone: "yǎn jing"},
          { character: "鼻子", pinyin: "bi zi", pinyinWithTone: "bí zi"},
          { character: "嘴巴", pinyin: "zui ba", pinyinWithTone: "zuǐ ba"},
          { character: "耳朵", pinyin: "er duo", pinyinWithTone: "ěr duo"},
          { character: "手", pinyin: "shou", pinyinWithTone: "shǒu"},
          { character: "脚", pinyin: "jiao", pinyinWithTone: "jiǎo"},
          { character: "胳膊", pinyin: "ge bo", pinyinWithTone: "gē bo"},
          { character: "腿", pinyin: "tui", pinyinWithTone: "tuǐ"},
          { character: "肚子", pinyin: "du zi", pinyinWithTone: "dù zi"},
          { character: "背", pinyin: "bei", pinyinWithTone: "bèi"},
          { character: "肩膀", pinyin: "jian bang", pinyinWithTone: "jiān bǎng"},
          { character: "膝盖", pinyin: "xi gai", pinyinWithTone: "xī gài"},
          { character: "牙齿", pinyin: "ya chi", pinyinWithTone: "yá chǐ"},
          { character: "头发", pinyin: "tou fa", pinyinWithTone: "tóu fa"}
        ],
        phenomena: [
          { character: "日出", pinyin: "ri chu", pinyinWithTone: "rì chū"},
          { character: "日落", pinyin: "ri luo", pinyinWithTone: "rì luò"},
          { character: "彩虹", pinyin: "cai hong", pinyinWithTone: "cǎi hóng"},
          { character: "闪电", pinyin: "shan dian", pinyinWithTone: "shǎn diàn"},
          { character: "雷声", pinyin: "lei sheng", pinyinWithTone: "léi shēng"},
          { character: "潮汐", pinyin: "chao xi", pinyinWithTone: "cháo xī"},
          { character: "地震", pinyin: "di zhen", pinyinWithTone: "dì zhèn"},
          { character: "火山", pinyin: "huo shan", pinyinWithTone: "huǒ shān"},
          { character: "海啸", pinyin: "hai xiao", pinyinWithTone: "hǎi xiào"},
          { character: "龙卷风", pinyin: "long juan feng", pinyinWithTone: "lóng juǎn fēng"},
          { character: "极光", pinyin: "ji guang", pinyinWithTone: "jí guāng"},
          { character: "流星", pinyin: "liu xing", pinyinWithTone: "liú xīng"},
          { character: "月食", pinyin: "yue shi", pinyinWithTone: "yuè shí"},
          { character: "日食", pinyin: "ri shi", pinyinWithTone: "rì shí"},
          { character: "沙尘暴", pinyin: "sha chen bao", pinyinWithTone: "shā chén bào"}
        ]

      ,
        idioms_numbers: [
          { character: "一心一意", pinyin: "yi xin yi yi", pinyinWithTone: "yī xīn yī yì"},
          { character: "三心二意", pinyin: "san xin er yi", pinyinWithTone: "sān xīn èr yì"},
          { character: "四面八方", pinyin: "si mian ba fang", pinyinWithTone: "sì miàn bā fāng"},
          { character: "五颜六色", pinyin: "wu yan liu se", pinyinWithTone: "wǔ yán liù sè"},
          { character: "七上八下", pinyin: "qi shang ba xia", pinyinWithTone: "qī shàng bā xià"},
          { character: "九牛一毛", pinyin: "jiu niu yi mao", pinyinWithTone: "jiǔ niú yī máo"},
          { character: "十全十美", pinyin: "shi quan shi mei", pinyinWithTone: "shí quán shí měi"}
        ],
        idioms_animals: [
          { character: "狐假虎威", pinyin: "hu jia hu wei", pinyinWithTone: "hú jiǎ hǔ wēi"},
          { character: "画蛇添足", pinyin: "hua she tian zu", pinyinWithTone: "huà shé tiān zú"},
          { character: "井底之蛙", pinyin: "jing di zhi wa", pinyinWithTone: "jǐng dǐ zhī wā"},
          { character: "守株待兔", pinyin: "shou zhu dai tu", pinyinWithTone: "shǒu zhū dài tù"},
          { character: "亡羊补牢", pinyin: "wang yang bu lao", pinyinWithTone: "wáng yáng bǔ láo"},
          { character: "对牛弹琴", pinyin: "dui niu tan qin", pinyinWithTone: "duì niú tán qín"},
          { character: "鹤立鸡群", pinyin: "he li ji qun", pinyinWithTone: "hè lì jī qún"}
        ],
        idioms_nature: [
          { character: "风和日丽", pinyin: "feng he ri li", pinyinWithTone: "fēng hé rì lì"},
          { character: "电闪雷鸣", pinyin: "dian shan lei ming", pinyinWithTone: "diàn shǎn léi míng"},
          { character: "冰天雪地", pinyin: "bing tian xue di", pinyinWithTone: "bīng tiān xuě dì"},
          { character: "春暖花开", pinyin: "chun nuan hua kai", pinyinWithTone: "chūn nuǎn huā kāi"},
          { character: "秋高气爽", pinyin: "qiu gao qi shuang", pinyinWithTone: "qiū gāo qì shuǎng"},
          { character: "狂风暴雨", pinyin: "kuang feng bao yu", pinyinWithTone: "kuáng fēng bào yǔ"}
        ],
        idioms_fables: [
          { character: "刻舟求剑", pinyin: "ke zhou qiu jian", pinyinWithTone: "kè zhōu qiú jiàn"},
          { character: "掩耳盗铃", pinyin: "yan er dao ling", pinyinWithTone: "yǎn ěr dào líng"},
          { character: "拔苗助长", pinyin: "ba miao zhu zhang", pinyinWithTone: "bá miáo zhù zhǎng"},
          { character: "自相矛盾", pinyin: "zi xiang mao dun", pinyinWithTone: "zì xiāng máo dùn"},
          { character: "画龙点睛", pinyin: "hua long dian jing", pinyinWithTone: "huà lóng diǎn jīng"},
          { character: "叶公好龙", pinyin: "ye gong hao long", pinyinWithTone: "yè gōng hào lóng"}
        ],
        idioms_study: [
          { character: "勤学好问", pinyin: "qin xue hao wen", pinyinWithTone: "qín xué hào wèn"},
          { character: "专心致志", pinyin: "zhuan xin zhi zhi", pinyinWithTone: "zhuān xīn zhì zhì"},
          { character: "不耻下问", pinyin: "bu chi xia wen", pinyinWithTone: "bù chǐ xià wèn"},
          { character: "学无止境", pinyin: "xue wu zhi jing", pinyinWithTone: "xué wú zhǐ jìng"},
          { character: "温故知新", pinyin: "wen gu zhi xin", pinyinWithTone: "wēn gù zhī xīn"},
          { character: "精益求精", pinyin: "jing yi qiu jing", pinyinWithTone: "jīng yì qiú jīng"}
        ],
        courses:[
           { character: "到", pinyin: "dao", pinyinWithTone: "dào"},
           { character: "轮滑馆", pinyin: "lun hua guan", pinyinWithTone: "lún huá guǎn"},
           { character: "博克斯", pinyin: "bo ke si", pinyinWithTone: "bó kè sī"},
           { character: "赢啦", pinyin: "ying la", pinyinWithTone: "yíng la"},
           { character: "病毒", pinyin: "bing du", pinyinWithTone: "bìng dú"},
           { character: "入侵", pinyin: "ru qin", pinyinWithTone: "rù qīn"},
           { character: "人体", pinyin: "ren ti", pinyinWithTone: "rén tǐ"},
           { character: "需要", pinyin: "xu yao", pinyinWithTone: "xū yào"},
           { character: "赶紧", pinyin: "gan jin", pinyinWithTone: "gǎn jǐn"},
           { character: "治疗", pinyin: "zhi liao", pinyinWithTone: "zhì liáo"},
           { character: "恭喜", pinyin: "gong xi", pinyinWithTone: "gōng xǐ"},
           { character: "成功", pinyin: "cheng gong", pinyinWithTone: "chéng gōng"},
           { character: "老鹰", pinyin: "lao ying", pinyinWithTone: "lǎo yīng"},
           { character: "打开", pinyin: "da kai", pinyinWithTone: "dǎ kāi"},
           { character: "窗帘", pinyin: "chuang lian", pinyinWithTone: "chuāng lián"},
           { character: "恭喜", pinyin: "gong xi", pinyinWithTone: "gōng xǐ"},
           { character: "嫦娥", pinyin: "chang e", pinyinWithTone: "cháng é"},
           { character: "发射", pinyin: "fa she", pinyinWithTone: "fā shè"},
           { character: "目的地", pinyin: "mu di di", pinyinWithTone: "mù dì dì"},
           { character: "附近", pinyin: "fu jin", pinyinWithTone: "fù jìn"},
           { character: "倒车", pinyin: "dao che", pinyinWithTone: "dǎo chē"},
           { character: "点我", pinyin: "dian wo", pinyinWithTone: "diǎn wǒ"},

        ]

      },
      // 词汇组标题映射
      groupTitles: {
        fruits: "水果分类",
        animals: "动物分类",
        colors: "颜色分类",
        numbers: "数字分类",
        direction: "方向分类",
        goods: "物品分类",
        weather: "天气分类",
        time: "时间分类",
        family: "家庭分类",
        nature: "自然分类",
        transport: "交通工具分类",
        professions: "职业分类",
        festivals: "节日分类",
        emotions: "情感分类",
        bodyparts: "身体部位分类",
        phenomena: "自然现象分类",
        idioms_numbers: "成语分类（数字）",
        idioms_animals: "成语分类（动物）",
        idioms_nature: "成语分类（自然）",
        idioms_fables: "成语分类（寓言）",
        idioms_study: "成语分类（学习）",
        courses:"课程相关词组"
      },
      
      currentIndex: 0,
      pinyinInputs: [], // 存储多个输入框的值
      score: 0,
      isCorrect: false,
      showResult: false,
      isChecking: false,
      isAnimating: false,
      
      // 学习报告相关数据
      learningProgress: [], // 记录每个词汇的学习情况
      attemptedWords: new Set(), // 记录已尝试过的词汇索引
      showReport: false, // 是否显示学习报告
      groupCompleted: false // 是否完成了一组词汇的学习
    };
  },
  computed: {
    // 根据路由参数获取当前词汇组
    currentGroup() {
      return this.$route.query.group || 'fruits';
    },
    // 获取当前词汇列表
    currentVocabulary() {
      return this.vocabularyGroups[this.currentGroup] || this.vocabularyGroups.fruits;
    },
    // 获取当前词汇组的标题
    currentGroupTitle() {
      return this.groupTitles[this.currentGroup] || "词汇学习";
    },
    // 获取当前词汇
    currentWord() {
      return this.currentVocabulary[this.currentIndex];
    },
    // 合并所有拼音输入框的值
    userInput() {
      return this.pinyinInputs.join(" ").trim();
    },
    // 计算完成的词汇数量
    completedCount() {
      return this.attemptedWords.size;
    },
    // 计算正确率
    correctPercentage() {
      if (this.learningProgress.length === 0) return 0;
      const correctCount = this.learningProgress.filter(item => item.correct).length;
      return Math.round((correctCount / this.learningProgress.length) * 100);
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 重置拼音输入框数组
    resetPinyinInputs() {
      this.pinyinInputs = Array(this.currentWord.character.length).fill("");
    },
    
    // 检查答案
    checkAnswer() {
      if (!this.userInput || this.isChecking) return;
      
      this.isChecking = true;
      this.showResult = true;
      
      // 分割正确答案为数组
      const correctPinyinParts = this.currentWord.pinyin.split(" ");
      let isAllCorrect = true;
      
      // 逐个检查每个字的拼音
      for (let i = 0; i < this.pinyinInputs.length; i++) {
        const userPinyin = this.pinyinInputs[i].toLowerCase().trim();
        const correctPinyin = (correctPinyinParts[i] || "").toLowerCase().trim();
        
        if (userPinyin !== correctPinyin) {
          isAllCorrect = false;
          break;
        }
      }
      
      this.isCorrect = isAllCorrect;
      
      // 更新学习进度
      this.updateLearningProgress(isAllCorrect);
      
      if (this.isCorrect) {
        this.score += 10;
        this.playCorrectSound();
      } else {
        this.playIncorrectSound();
      }
      
      // 设置自动隐藏结果
      setTimeout(() => {
        this.showResult = false;
        this.isChecking = false;
        
        // 检查是否所有词汇都已经尝试过
        if (this.attemptedWords.size >= this.currentVocabulary.length && !this.groupCompleted) {
          this.groupCompleted = true;
          this.showStudyReport();
        } else if (this.isCorrect) {
          this.nextWord();
        }
      }, 1000); // 2.5秒后隐藏结果和解锁界面
    },
    
    // 更新学习进度
    updateLearningProgress(isCorrect) {
      // 记录当前索引已经尝试过
      this.attemptedWords.add(this.currentIndex);
      
      // 检查该词汇是否已经在学习进度中
      const existingIndex = this.learningProgress.findIndex(
        item => item.character === this.currentWord.character
      );
      
      if (existingIndex !== -1) {
        // 如果存在，更新状态
        this.learningProgress[existingIndex].correct = isCorrect;
        this.learningProgress[existingIndex].attempts += 1;
      } else {
        // 如果不存在，添加新记录
        this.learningProgress.push({
          character: this.currentWord.character,
          pinyin: this.currentWord.pinyin,
          pinyinWithTone: this.currentWord.pinyinWithTone,
          correct: isCorrect,
          attempts: 1
        });
      }
    },

    completeLevelAndSave() {
      const completedLevels = JSON.parse(localStorage.getItem('completedLevels') || '[]')
      if (!completedLevels.includes(this.$route.query.levelId)) {
        completedLevels.push(this.$route.query.levelId)
        localStorage.setItem('completedLevels', JSON.stringify(completedLevels))
      }
    },
    
    // 显示学习报告
    showStudyReport() {
      this.completeLevelAndSave();
      setTimeout(() => {
        this.showReport = true;
      }, 500);
    },
    
    // 关闭学习报告
    closeReport() {
      this.showReport = false;
    },
    
    // 重新开始学习
    restartLearning() {
      this.score = 0;
      this.currentIndex = 0;
      this.learningProgress = [];
      this.attemptedWords = new Set();
      this.groupCompleted = false;
      this.resetPinyinInputs();
      this.closeReport();
    },
    
    // 处理键盘事件
    handleKeydown(event) {
      // 检测是否按下Shift+Enter
      if (event.key === 'Enter' && event.shiftKey) {
        event.preventDefault(); // 阻止默认行为
        this.checkAnswer();
      }
    },
    
    nextWord() {
      this.showResult = false;
      this.isAnimating = true;
      
      setTimeout(() => {
        // 查找未尝试过的词汇
        if (this.attemptedWords.size < this.currentVocabulary.length) {
          // 找到下一个未尝试过的词汇
          let nextIndex = (this.currentIndex + 1) % this.currentVocabulary.length;
          let loopCount = 0;
          
          // 如果已经学习的词汇数量小于总词汇数量，但所有词汇都已尝试过，那么选择一个错误的词汇再次学习
          if (this.attemptedWords.size === this.currentVocabulary.length) {
            const incorrectItems = this.learningProgress.filter(item => !item.correct);
            if (incorrectItems.length > 0) {
              const targetChar = incorrectItems[0].character;
              nextIndex = this.currentVocabulary.findIndex(item => item.character === targetChar);
            }
          } else {
            // 寻找未尝试过的词汇
            while (this.attemptedWords.has(nextIndex) && loopCount < this.currentVocabulary.length) {
              nextIndex = (nextIndex + 1) % this.currentVocabulary.length;
              loopCount++;
            }
          }
          
          this.currentIndex = nextIndex;
        } else {
          // 所有词汇都尝试过了，显示学习报告
          if (!this.groupCompleted) {
            this.groupCompleted = true;
            this.showStudyReport();
          } else {
            // 如果报告已经显示过，就循环到下一个词汇
            this.currentIndex = (this.currentIndex + 1) % this.currentVocabulary.length;
          }
        }
        
        this.resetPinyinInputs();
        this.isAnimating = false;
        this.$nextTick(() => {
          if (this.$refs.pinyinInput0 && this.$refs.pinyinInput0[0]) {
            this.$refs.pinyinInput0[0].focus();
          }
        });
      }, 300);
    },
    
    previousWord() {
      this.showResult = false;
      this.isAnimating = true;
      
      setTimeout(() => {
        this.currentIndex = (this.currentIndex - 1 + this.currentVocabulary.length) % this.currentVocabulary.length;
        this.resetPinyinInputs();
        this.isAnimating = false;
        this.$nextTick(() => {
          if (this.$refs.pinyinInput0 && this.$refs.pinyinInput0[0]) {
            this.$refs.pinyinInput0[0].focus();
          }
        });
      }, 300);
    },
    
    playCorrectSound() {
      // 播放正确音效
      // 临时使用在线音效
      const audio = new Audio("https://wugecdn.steam.fun/typefun/music/correct.mp3");
      audio.play();
    },
    
    playIncorrectSound() {
      // 播放错误音效
      // 临时使用在线音效
      const audio = new Audio("https://wugecdn.steam.fun/typefun/music/fail.mp3");
      audio.play();
    }
  },
  mounted() {
    this.resetPinyinInputs();
    // 添加键盘事件监听
    window.addEventListener('keydown', this.handleKeydown);
    
    this.$nextTick(() => {
      if (this.$refs.pinyinInput0 && this.$refs.pinyinInput0[0]) {
        this.$refs.pinyinInput0[0].focus();
      }
    });
  },
  beforeDestroy() {
    // 移除键盘事件监听，防止内存泄漏
    window.removeEventListener('keydown', this.handleKeydown);
  },
  watch: {
    // 监听当前词汇的变化，重置输入框
    currentIndex() {
      this.resetPinyinInputs();
    },
    // 监听路由参数变化，重置学习状态
    currentGroup() {
      this.score = 0;
      this.currentIndex = 0;
      this.learningProgress = [];
      this.attemptedWords = new Set();
      this.groupCompleted = false;
      this.resetPinyinInputs();
      this.closeReport();
    }
  }
};
</script>

<style scoped>
.typing-planet-container {
  font-family: "Comic Sans MS", "楷体", cursive;
  margin: 15px;
  padding: 20px;
  background: white;
  border-radius: 20px;
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.typing-planet-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://wugecdn.steam.fun/typefun/images/pattern.png');
  background-size: 200px;
  opacity: 0.05;
  pointer-events: none;
  z-index: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
  position: relative;
  z-index: 1;
}

.header-left {
  min-width: 100px;
}

.back-button {
  display: flex;
  align-items: center;
  padding: 10px 18px;
  color: #909399;
  border: none;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.back-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(25, 118, 210, 0.4);
}

.back-button:active {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.3);
}

.back-icon {
  font-style: normal;
  margin-right: 8px;
  font-weight: bold;
  font-size: 18px;
}

.header h1 {
  color: #1565c0;
  font-size: 32px;
  text-shadow: 2px 2px 0px rgba(255, 255, 255, 0.8), 3px 3px 0px rgba(0, 0, 0, 0.1);
  margin: 0;
  letter-spacing: 1px;
}

.score-board {
  background: linear-gradient(135deg, #ff9800 0%, #ff5722 100%);
  padding: 10px 22px;
  border-radius: 50px;
  font-size: 20px;
  font-weight: bold;
  color: white;
  box-shadow: 0 5px 10px rgba(255, 87, 34, 0.3);
  display: flex;
  align-items: center;
  border: 3px solid white;
}

.star-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  animation: pulse 2s infinite;
}

.game-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 20px;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.fruit-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: center;
  position: relative;
}

.fruit-card.animated {
  transform: scale(0.9) rotate(5deg);
}

.card-content {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  padding: 25px 40px;
  border-radius: 25px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border: 5px solid white;
  overflow: hidden;
}

.card-content::before {
  content: '';
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
}

.fruit-image {
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
  object-fit: contain;
  margin-top: 15px;
  filter: drop-shadow(0 5px 5px rgba(0, 0, 0, 0.2));
  transition: all 0.3s;
  animation: float 3s ease-in-out infinite;
}

.fruit-character {
  font-size: 60px;
  font-weight: bold;
  color: #2e7d32;
  text-shadow: 2px 2px 0 white, 4px 4px 0 rgba(0, 0, 0, 0.1);
  line-height: 1.2;
  margin: 0;
}

.pinyin-input-area {
  width: 100%;
  text-align: center;
  padding: 20px;
  border-radius: 15px;
}

.prompt {
  font-size: 20px;
  margin-bottom: 15px;
  color: #424242;
  font-weight: 500;
}

.tone-hint {
  font-size: 30px;
  color: #f57c00;
  font-weight: bold;
  margin-left: 5px;
  background-color: rgba(255, 235, 59, 0.2);
  padding: 3px 8px;
  border-radius: 4px;
}

.pinyin-inputs-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.character-pinyin-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.character-label {
  font-size: 30px;
  font-weight: bold;
  color: #1565c0;
  margin-bottom: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 3px solid #bbdefb;
  text-shadow: 1px 1px 0 white;
}

.pinyin-input {
  width: 90px;
  padding: 12px 8px;
  font-size: 18px;
  border: 3px solid #90caf9;
  text-align: center;
  outline: none;
  transition: all 0.3s;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
  font-family: "Comic Sans MS", "楷体", cursive;
}

.pinyin-input:focus {
  border-color: #1e88e5;
  background-color: #e3f2fd;
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(30, 136, 229, 0.2);
}

.check-button {
  padding: 12px 30px;
  background: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 6px 12px rgba(67, 160, 71, 0.3);
  margin-top: 15px;
  position: relative;
  overflow: hidden;
  border: 3px solid white;
}

.check-button:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 8px 15px rgba(67, 160, 71, 0.4);
}

.check-button:active {
  transform: translateY(-1px) scale(0.98);
}

.check-button:disabled {
  background: linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.check-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%);
  transform: translateX(-100%);
  transition: transform 0.3s;
}

.check-button:hover:before {
  transform: translateX(100%);
  transition: transform 0.5s;
}

.check-icon {
  display: inline-block;
  margin-right: 5px;
  font-style: normal;
}

.tip-text {
  margin-top: 10px;
  font-size: 14px;
  color: #757575;
  font-style: italic;
  margin-bottom: 15px;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;
}

kbd {
  background-color: #f8f9fa;
  border: 1px solid #d1d5da;
  border-radius: 3px;
  box-shadow: inset 0 -1px 0 #d1d5da;
  color: #444d56;
  display: inline-block;
  font-family: monospace;
  font-size: 11px;
  line-height: 10px;
  padding: 3px 5px;
  vertical-align: middle;
}

.result-message {
  padding: 10px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  left: 0;
  right: 0;
  top: 25%;
  margin: auto;
  z-index: 100;
  pointer-events: none;
}

.animated-feedback {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
  animation: popIn 0.5s ease forwards, fadeOut 0.5s ease forwards 2s;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  width: 90%;
  max-width: 500px;
  position: relative;
  overflow: hidden;
  justify-content: center;
  border: 5px solid white;
}

.feedback-content {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
}

.feedback-text {
  font-size: 22px;
  margin-right: 8px;
  font-weight: bold;
}

.correct {
  background: linear-gradient(135deg, #81c784 0%, #4caf50 100%);
  color: white;
  border: none;
  box-shadow: 0 8px 15px rgba(76, 175, 80, 0.3);
}

.correct::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.1) 100%);
  transform: translateX(-100%);
  animation: shimmer 2s infinite;
  z-index: 1;
}

.incorrect {
  background: linear-gradient(135deg, #ef9a9a 0%, #e57373 100%);
  color: white;
  border: none;
  box-shadow: 0 8px 15px rgba(229, 115, 115, 0.3);
}

.incorrect::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0.1) 100%);
  transform: translateX(-100%);
  animation: shimmer 2s infinite;
  z-index: 1;
}

.correct-answer {
  font-weight: bold;
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 4px 10px;
  border-radius: 8px;
  margin-left: 8px;
  margin-right: 8px;
  letter-spacing: 1px;
}

.result-icon {
  width: 45px;
  height: 45px;
  margin-left: 10px;
  z-index: 2;
  filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.2));
}

.bounce-animation {
  animation: bounceIcon 1s ease infinite;
}

.shake-animation {
  animation: shakeIcon 0.5s ease infinite;
}

.confetti-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.confetti {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #ffeb3b;
  animation: fallConfetti 2s ease-out forwards var(--delay);
  opacity: 0;
  top: 0;
  left: calc(var(--n) * 5%);
  border-radius: 2px;
}

.confetti:nth-child(2n) {
  background-color: #ff5722;
  width: 8px;
  height: 14px;
}

.confetti:nth-child(3n) {
  background-color: #4caf50;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.confetti:nth-child(4n) {
  background-color: #2196f3;
  width: 7px;
  height: 16px;
  transform: rotate(20deg);
}

.navigation {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 15px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.nav-button {
  padding: 10px 22px;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  border: 3px solid white;
}

.prev-button {
  background: linear-gradient(135deg, #7986cb 0%, #3f51b5 100%);
}

.next-button {
  background: linear-gradient(135deg, #5c6bc0 0%, #3949ab 100%);
}

.nav-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.nav-icon {
  font-style: normal;
  margin: 0 5px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  70% {
    opacity: 1;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

@keyframes bounceIcon {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-12px) scale(1.2); }
}

@keyframes shakeIcon {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px) rotate(-5deg); }
  75% { transform: translateX(5px) rotate(5deg); }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes fallConfetti {
  0% {
    transform: translateY(-10px) translateX(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100px) translateX(calc(30px * (var(--n) - 10))) rotate(720deg);
    opacity: 0;
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

/* 学习报告样式 */
.report-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease forwards;
}

.report-modal {
  background: white;
  width: 90%;
  max-width: 800px;
  border-radius: 20px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.4s ease-out forwards;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 6px solid #1976d2;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}

.report-header h2 {
  margin: 0;
  font-size: 28px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  letter-spacing: 1px;
}

.close-report {
  background: none;
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-report:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.report-content {
  padding: 25px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.report-summary {
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.report-total {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
}

.report-icon-container {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #bbdefb 0%, #64b5f6 100%);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 10px rgba(33, 150, 243, 0.2);
}

.report-icon {
  width: 50px;
  height: 50px;
}

.report-stats {
  flex: 1;
}

.report-stats p {
  margin: 8px 0;
  font-size: 16px;
  color: #424242;
}

.highlight {
  font-weight: bold;
  color: #1565c0;
  font-size: 20px;
}

.report-progress {
  margin-top: 10px;
}

.progress-bar {
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(to right, #1976d2, #64b5f6);
  border-radius: 10px;
  transition: width 1s ease-in-out;
}

.report-details {
  background-color: #f9f9f9;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.report-details h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #1976d2;
  font-size: 22px;
  border-bottom: 2px dashed #bbdefb;
  padding-bottom: 8px;
}

.vocabulary-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  max-height: 30vh;
  overflow-y: auto;
  padding-right: 10px;
}

.vocabulary-item {
  background-color: white;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s;
}

.vocabulary-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.vocab-character {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.vocab-pinyin {
  font-size: 16px;
  color: #757575;
  margin-bottom: 8px;
}

.vocab-status {
  font-size: 18px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-top: 5px;
}

.status-correct {
  background-color: #1976d2;
}

.status-incorrect {
  background-color: #f44336;
}

.status-icon {
  font-style: normal;
}

.report-actions {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 10px;
}

.restart-button, .continue-button {
  padding: 12px 25px;
  border: none;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.restart-button {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
}

.continue-button {
  background: linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%);
  color: white;
}

.restart-button:hover, .continue-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.restart-icon, .continue-icon {
  font-style: normal;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0; 
    transform: translateY(50px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}
</style>
